import { makeVar } from '@apollo/client';

export const termsWarningTemporaryHiddenVar = makeVar(false);

export const appBarHeightVar = makeVar(0);
